<template>
  <b-card class="rounded-lg">
    <template #header>
      <div
        class="d-flex justify-content-between align-items-center w-100 h-100 pb-1"
        style="border-bottom: 2px solid rgb(238, 238, 238)"
      >
        <h4 class="text-dark m-0">
          Designations {{ memberDesignations.length > 0 ? `(${memberDesignations.length})` : "" }}
        </h4>

        <div
          v-if="can('member_designations:CanAddNew')"
          class="d-flex align-items-center"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="isAddOrUpdateActive = true"
          >
            <span class="align-middle text-lg">Add New Designation</span>
          </b-button>
        </div>
      </div>
    </template>

    <div class="" style="height: 580px; overflow-y: scroll">
      <b-overlay :show="loading" opacity="0.5">
        <add-or-update-member-designation-modal
          :is-add-or-update-active.sync="isAddOrUpdateActive"
          :update-data="updateData"
          :participant-types="memberTypes"
          @refetchData="fetchAllData"
          @resetUpdateData="resetUpdateData"
        />

        <div>
          <list-table
            :records="memberDesignations"
            :columns="tableColumns"
            :total-records="totalRecords"
            :current-page-number.sync="currentPage"
            :search-filter.sync="search"
            :show-search="true"
            :show-filter-by-default="true"
          >

            <template #cell(_id)="data">
              <div>
                <b-button
                  v-b-toggle="`collapse-${data.item._id}`"
                  variant="primary"
                  class=""
                >
                  <span>{{ data.item.designation }}</span>
                </b-button>

                <b-collapse
                  :id="`collapse-${data.item._id}`"
                  class="card-body"
                  style="
                    border-left: 2px solid gray;
                    margin-left: 8px;
                    margin-top: 10px;
                  "
                >
                  <list-table
                    :records="data.item.categories"
                    :columns="[
                      { key: 'designation', sortable: false },
                      { key: 'status', sortable: false },
                      { key: 'actions', sortable: false },
                    ]"
                    :current-page-number="1"
                    :show-import-button="false"
                    :show-export-button="false"
                    :show-search="false"
                    :total-records="data.item.categories.length"
                  >
                    <template #cell(status)="value">
                      <b-badge
                        pill
                        :variant="`light-${resolveStatusVariant(
                          value.item.status
                        )}`"
                        class="text-capitalize"
                      >
                        {{ getUserStatusText(value.item.status) }}
                      </b-badge>
                    </template>
               
                    <template #cell(actions)="action">
                      <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </template>

                        <b-dropdown-item
                          v-if="can('member_designations:CanUpdate')"
                          @click="onEdit(action.item)"
                        >
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>

                        <b-dropdown-item
                          v-if="can('member_designations:CanDelete')"
                          @click="onDelete(action.item._id)"
                        >
                          <feather-icon icon="DeleteIcon" />
                          <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>

                    <template #cell(answer)="answer">
                      <span style="color: dodgerblue">{{
                        answer.value === true
                          ? "Yes"
                          : answer.value === false
                          ? "No"
                          : answer.value
                      }}</span>
                    </template>
                  </list-table>
                </b-collapse>
              </div>
            </template>
          </list-table>
        </div>
      </b-overlay>
    </div>
  </b-card>
</template>


  
  <script>
  import ListTable from "@core/components/ListTable/ListTable.vue";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  import AddOrUpdateMemberDesignationModal from "@/@core/components/shared/church/AddOrUpdateMemberDesignationModal.vue";

  import Ripple from 'vue-ripple-directive';
  
  import {
    BAlert,
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCol,
    BCollapse,
    BDropdown,
    BDropdownGroup,
    BDropdownItem,
    BImg,
    BOverlay,
    BRow,
    VBToggle,
  } from "bootstrap-vue";
  
  import { debounce, get } from "lodash";
  
  const watchHandler = {
    handler(){
      this.debounceFetchAllData()
    },
    immediate: false
  }
  
  const watchHandlerRequiresPageReset = {
    handler(){
      this.currentPage = 1;
      this.debounceFetchAllData()
    },
    immediate: false
  }
  
  export default {
    name: "Designation",
    components: {
      BAlert,
      BAvatar,
      BBadge,
      BButton,
      BCard,
      BCol,
      BCollapse,
      BDropdown,
      BDropdownGroup,
      BDropdownItem,
      BImg,
      BOverlay,
      BRow,
      VBToggle,
      ListTable,
      AddOrUpdateMemberDesignationModal
    },
    directives: {
      Ripple,
      "b-toggle": VBToggle,

    },
    data() {
      return {
        loading: false,
        memberTypes: [],
        memberDesignations: [],
  
        search: "",
        titleFilter: null,
  
        updateData: null,
        debounceFetchAllData: null,
        isAddOrUpdateActive: false,
  
        tableColumns: [
        { key: "_id", label: "Member Type", sortable: false },
      ],
      }
    },
    computed: {
      perPage: {
        get() {
          return this.$store.getters[`navigation/recordsPerPage`];
        },
        set(value){
          this.$store.commit(`navigation/UPDATE_RECORDS_PER_PAGE`, value)
        }
      },
      currentPage: {
        get() {
          return this.$store.getters[`navigation/currentPage`];
        },
        set(value){
          this.$store.commit(`navigation/UPDATE_CURRENT_PAGE_NUMBER`, value)
        }
      },
      totalRecords: {
        get(){
          return this.$store.getters[`navigation/totalRecords`];
        },
        set(value){
          this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
        }
      },
    },
    watch: {
      currentPage: watchHandler,
      search: watchHandlerRequiresPageReset,
      perPage: watchHandlerRequiresPageReset,
      titleFilter: watchHandlerRequiresPageReset,
    },
    created() {
      this.fetchMemberTypes();
      this.debounceFetchAllData = debounce(this.fetchAllData, 500);
  
      const {
        search,
        page = 1,
        limit = this.perPage
      } = this.$route.query;
  
      this.search = search;
      this.perPage = +limit;
      this.currentPage = +page;
    },
    methods: {
      async fetchMemberTypes() {
        try {
          this.loading = true;
  
          const query = {
            page: 1,
            limit: 1000,
          }
  
          const request = await this.useJwt().mainService.memberTypes.list(query);
          const { data } = request.data;
  
          this.memberTypes = data.map((member_type) => ({ label: member_type.title, value: member_type._id }));
        } catch (error) {
          const error_message = get(error, "response.data.message") || error.message
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              variant: 'danger',
              text: error_message,
              icon: 'AlertTriangleIcon',
            },
          });
        } finally {
          this.loading = false;
        }
      },
      async fetchAllData() {
        try {
          this.loading = true;
  
          const query = {
            limit: this.perPage,
            search: this.search,
            page: this.currentPage,
            participant: this.titleFilter,
          }
          await this.$router.push({ query }).catch(() => {});
  
          const request = await this.useJwt().mainService.memberDesignations.list(query);
          const { data, pagination } = request.data;
          console.log('pagination', pagination)
          this.totalRecords = pagination.totalRecords;
          this.perPage = pagination.limit;
          this.memberDesignations = data;
        } catch (error) {
          const error_message = get(error, "response.data.message") || error.message
          console.log("error_message", error_message);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        } finally {
          this.loading = false;
        }
      },
      async onDelete(id){
        try {
          this.loading = true;
  
          const result = await this.$swal({
            title: 'Confirm Delete?',
            text: "Do you want to delete this Title?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, proceed.',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          });
  
          if (!result.value) {
            return;
          }
  
          await this.useJwt().mainService.memberDesignations.delete(id);
          await this.fetchAllData()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Designation Deleted Successfully'
            },
          });
        } catch (error) {
          const error_message = get(error, "response.statusText") || error.message;
  
          this.$nextTick(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error!',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: error_message
              },
            });
          })
        } finally {
          this.loading = false;
        }
      },
      onEdit(update){
        this.updateData = update;
        this.isAddOrUpdateActive = true;
      },
      resetUpdateData(){
        if (this.updateData){
          this.updateData = null
        }
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>
